import { render, staticRenderFns } from "./DataBody6.vue?vue&type=template&id=1e05991e&scoped=true&"
import script from "./DataBody6.vue?vue&type=script&lang=js&"
export * from "./DataBody6.vue?vue&type=script&lang=js&"
import style0 from "./DataBody6.vue?vue&type=style&index=0&id=1e05991e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e05991e",
  null
  
)

export default component.exports